// astro vue will render empty page if import vue from 'vue'
// @ts-ignore
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import hybridPage from '@/lib/hybridPage'
import { GaGeneralPageName } from '@/assets/ts/customEvent'
import { setCurrentGaPageName } from '@/lib/utils'
import MercariCollectionListing from '@/pages/mercari-collection-listing/components/_MercariCollectionListing.vue'

hybridPage()

createApp({
	name: 'Mercari Collection Listing Page',
	components: {
		MercariCollectionListing,
	},
	setup() {
		setCurrentGaPageName(GaGeneralPageName.MercariCollectionListing)

		const { mercariCollectionListingPageContent } = window.pageContent

		return {
			mercariCollectionListingPageContent,
		}
	},
}).mount('#bsMain')
